import { render } from "./TvmMultiSelectSuggestions.vue?vue&type=template&id=fd621c50&scoped=true"
import script from "./TvmMultiSelectSuggestions.js?vue&type=script&lang=js&external"
export * from "./TvmMultiSelectSuggestions.js?vue&type=script&lang=js&external"

import "./TvmMultiSelectSuggestions.vue?vue&type=style&index=0&id=fd621c50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd621c50"],['__file',"src/components/ChatWidget/TvmMultiSelectSuggestions/TvmMultiSelectSuggestions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd621c50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd621c50', __exports__)) {
    api.reload('fd621c50', __exports__)
  }
  
  module.hot.accept("./TvmMultiSelectSuggestions.vue?vue&type=template&id=fd621c50&scoped=true", () => {
    api.rerender('fd621c50', render)
  })

}


export default __exports__